/* eslint-disable @nx/enforce-module-boundaries */
'use client';
import { MyBridgeLogoMain } from '@mybridge/icons/MyBridgeLogo';
// import branch from 'branch-sdk'
import { SearchIcon } from '@mybridge/icons/Search';
import {
  Avatar,
  Button,
  IconButton,
  Popover,
  PopoverBody,
  PopoverContent,
  PopoverTrigger,
  Portal,
  Progress,
  Spinner,
  Text,
} from '@mybridge/ui';
import { Input, InputGroup, InputLeftElement } from '@mybridge/ui/input';
import {
  Box,
  Circle,
  HStack,
  Spacer,
  Stack,
  VStack,
} from '@mybridge/ui/layout';
import Link from 'next/link';
import { useRouter } from 'next/router';
import { useContext, useEffect, useRef, useState } from 'react';
import { useSelector } from 'react-redux';
import { SearchContext } from 'v4/snippets/search/context';
import { AuthHeader } from '../auth/auth-header';
import { PrependPageHeadTitle } from '../custom-head';
import { useDispatch } from 'react-redux';
import styles from './index.module.scss';
import {
  CalendarIcon,
  CalendarNewIcon,
  DashboardLayoutIcon,
  DiskIcon,
  DiskNewIcon,
  EventClockIcon,
  FolderIcon,
  GroupIcon,
  HomeIcon,
  LayoutModeIcon,
  MyBridgeCircleIcon,
  SimpleCloseIcon,
  UsersIconColored,
} from '@mybridge/icons';
import { isMobile, isTablet } from 'react-device-detect';
import { useDisclosure, useMediaQuery } from '@mybridge/ui';
import { ProfileMenu } from '../auth/auth-header/profile-menu';
import MobileDrawerMenu from '../auth/mobile-drawer-menu';
import { logout, setChatLoggedIn } from 'v4/store/actions/auth.actions';
import {
  getRecentSearch,
  deleteRecentSearchID,
  generateMatrixId,
} from 'v4/store/actions/global.data.actions';
import RecentSearchListBox from 'v4/components/header/recent-search-box';
import { JobsListingSearchBar } from '../jobs/search-bar';
import { JobsListingContext } from '../jobs/context';
import NotificationDropdown from '../auth/auth-header/notifications';
import ShareLinkModalPublic from '../../pages/appointment/[slug]/share-link-modal'
import { checkAppointmentSlug } from 'v4/store/actions/calendar.actions';
import { getUserFullName } from 'v4/lib/commons';
import { css } from '@chakra-ui/react';
import { setDashboardClicked, toggleDashboardClicked } from 'v4/store/slices/dashboardAciveSlice';
import { setNotificationClicked } from 'v4/store/slices/notificationActiveSlice';
import { useTranslator } from '@mybridge/ui/custom-hooks/useTranslation';
import { useDirection } from '@mybridge/ui/custom-hooks/useDirection';
import { ANALYTICS_EVENTS, trackEvent } from 'v4/utils/analyticsEvents';

const Header = (props) => {
  const { loggedIn, pageLoaded } = useSelector((state) => state.user);
  const { allDegreeConnectionsArr } = useSelector((state) => state.connection);
  const { globalNotifCount } = useSelector((state) => state.notifications);
  const { loading } = useSelector((state) => state.userProfile);
  const { recentSearches, loading: searchLoading } = useSelector(
    (state) => state.globalData
  );
  const { isMeetingStarted } = useSelector(
    (state) => state.meeting
  );
  const { isPublicAppointment } = useSelector((state) => state.calendar);
  const { search, setSearch, setActiveTab } = useContext(SearchContext);
  const [openShareModal,setOpenShareModal]=useState(false)
  const [getAccountInfo, setGetAccountInfo] = useState([]);
  const dispatch = useDispatch();
  const { push, pathname, query } = useRouter();
  const isDiskPage = pathname?.includes('profile/disk');
  const sideDrawerDisc = useDisclosure();
  const searchBoxDisc = useDisclosure();
  const notifDisc = useDisclosure();
  const inputRef = useRef(null);
  const [newSearch, setNewSearch] = useState([]);
  const isJobsPage = pathname?.includes('jobs');
  // const isAppointmentPublicPage = pathname?.includes('appointment');
  const isAppointmentPublicPage = pathname?.startsWith('/appointment');
  const [userInfo, setUserInfo] = useState([]);
  const [className, setClassName] = useState('hstack_large'); 
  const [inputField,setInputField]=useState("");
  const [tempSearch, setTempSearch] = useState("");
  const router=useRouter()
  const { t } = useTranslator();
  const direction = useDirection();
    const { userProfileInfo } = useSelector((state) => state.userProfile);
  const userSlug = userProfileInfo?.slug || 'anonymous';
  const currentLanguage = useSelector((state) => state.translation.language);
  const [maxTabletDimension767] = useMediaQuery('(max-width: 767px)');
  const [maxTabletDimension992] = useMediaQuery('(max-width: 992px)');
  const maxTabletDimension = loggedIn ? maxTabletDimension767 : maxTabletDimension992;
  const isMobileOrTablet = isMobile || isTablet || maxTabletDimension;
  const side = typeof window !== 'undefined' ? document.documentElement.dir : 'ltr';
  const isPublicPage=pathname==='/g/people'||pathname==='/g/jobs'||pathname==='/g/pages'||pathname==='/g/teams'||pathname==='/g/events'||pathname==='/g/articles'||(pathname==='/'&&!loggedIn)
  const isProfile=pathname==='/profile/me'||pathname==='/profile/about'||pathname==='/profile/photos'||pathname==='/profile/videos'
  const connections = allDegreeConnectionsArr?.[0] ?? [];

  useEffect(()=>{
    if(loggedIn && connections?.length){
      dispatch(generateMatrixId()).then((res) => {
        localStorage.setItem("matrixData", JSON.stringify(res?.payload?.results || []));
      });
    }
  }, [loggedIn, connections?.length])

  useEffect(() => {
    let array = recentSearches?.results;
    let temp = [];
    let newArray = array?.filter((ele) => {
      if (!temp.includes(ele.query) && temp.length < 5) {
        temp.push(ele.query);
        return true;
      } else {
        return false;
      }
    });
    setNewSearch(newArray);
  }, [recentSearches]);

  const isDashboardClicked = useSelector(
    (state) => state.dashboardActive.isDashboardClicked
  );


  const handleSearch = (e) => {
    if (e.keyCode === 13) { // Enter key
      const val = e?.target?.value;
      const formattedQuery = val.trim().replace(/\s+/g, ' ');

      if (ANALYTICS_EVENTS.Search) {
        trackEvent(ANALYTICS_EVENTS.Search, userSlug);
      }
      setSearch(formattedQuery);
      if (formattedQuery.length > 2) {
        setActiveTab?.(formattedQuery.length ? 'all' : 'posts');
        searchBoxDisc.onClose();
        push('/g/?query=' + encodeURIComponent(formattedQuery));
      } else {
        push('/');
      }
    }
  };
  

  const handleSearchKeyDown = (e, mouseClick=false) => {
    if (e?.keyCode === 13 || e?.key === 'Enter' || mouseClick) {
      if (e?.preventDefault) e.preventDefault();
      const formattedQuery = (tempSearch || '').trim().replace(/\s+/g, ' ');

      setSearch(formattedQuery);
      setActiveTab?.(formattedQuery.length ? 'all' : 'posts');
      searchBoxDisc.onClose();
      if (formattedQuery) {
        push('/g/?query=' + encodeURIComponent(formattedQuery));
      } else {
        push('/g');
      }
    }
  };
  
  const handleInputChange = (e) => {
    setTempSearch(e.target.value); // Update tempSearch for real-time input
  };

  useEffect(() => {
    if (query.query) {
      const formattedQuery = query.query.trim().replace(/\s+/g, ' ');
      setSearch(formattedQuery); // Update the actual search state
      setTempSearch(formattedQuery); // Update the temporary input state
    }
  }, [query.query]);

  const handleRecentSearch = (e) => {
    const val = e;
    setSearch(val);
    setActiveTab?.(val?.length ? 'all' : 'posts');
    if (val?.length) {
      push('/g/?query=' + encodeURIComponent(e));
    } else {
      push('/');
    }
  };


  const updateClassName = () => {
    const zoomLevel = window.devicePixelRatio;

    if (loggedIn&&zoomLevel >= 1.35) {
      setClassName('hstack_small');
    } else if (loggedIn&&zoomLevel >= 1.1) {
      setClassName('hstack_medium');
    } else {
      if(loggedIn){
        setClassName('hstack_large');

      }
    }
  };


  const updateClassNameLoggedout = () => {
    const zoomLevel = window.devicePixelRatio;

    if (!loggedIn&&zoomLevel >= 1.35) {
      setClassName('hstack_small_loggedOut');
    } else if (!loggedIn&&zoomLevel >= 1.1) {
      setClassName('hstack_medium_loggedOut');
    } else {
     
        setClassName('hstack_large_loggedOut');

  
    }
  };

  useEffect(() => {
if(loggedIn){

  updateClassName();
  window.addEventListener('resize', updateClassName);
  return () => {
    window.removeEventListener('resize', updateClassName);
  };
}else if (!loggedIn){
  

  updateClassNameLoggedout();
  window.addEventListener('resize', updateClassNameLoggedout);
  return () => {
    window.removeEventListener('resize', updateClassNameLoggedout);
  };
}
    // Event listener for window focus
    const handleWindowFocus = () => {
      // Check if access token exists in localStorage
      const accessToken = localStorage.getItem('access');

      if (accessToken) {
        // Parse the token to get the expiration time
        const { exp } = JSON.parse(atob(accessToken.split('.')[1]));

        // Check if the token is expired
        const isTokenExpired = Date.now() >= exp * 1000;
        if (isTokenExpired) {

          dispatch(logout());
          push('/');
        } else {
          // console.log('Access token is still valid.');
        }
        // } else {
        //   dispatch(logout());
        //   push('/');
      }
    };

    // Attach the event listener to the window focus event
    window.addEventListener('focus', handleWindowFocus);

    // Cleanup the event listener when the component is unmounted
    return () => {
      window.removeEventListener('focus', handleWindowFocus);
    };
  }, [loggedIn]);

  useEffect(() => {
    if (inputRef.current) {
      inputRef.current.focus();
    }
  }, [inputRef]);

  useEffect(() => {
    if (recentSearches?.count === 0 && loggedIn) dispatch(getRecentSearch());
  }, [loggedIn]);

  const handleRecentDelete = () => {
    const payload = { id: 'all' };
    dispatch(deleteRecentSearchID(payload)).then((res) => {
      if (res) dispatch(getRecentSearch());
    });
  };

  const handleCloseShareLinkModal=()=>{
    setOpenShareModal(false)
  }


  useEffect(()=>{
    if(!isAppointmentPublicPage||!query?.slug)return

    dispatch(checkAppointmentSlug({ search: query.slug })).then((res) => {


      // if (res.payload.results.length > 0) {
        setGetAccountInfo(res.payload.results?.[0]);
      // }
    });
  },[query?.slug])

  const handleStopPropogation = () => {
    dispatch(setDashboardClicked(false));
    dispatch(setNotificationClicked(false));
  }

useEffect(()=>{
if(!router?.query?.query?.length){
  setTempSearch("")
}

},[router?.query?.query?.length])
  return (<>
  {(
  <>
  <PrependPageHeadTitle>
    {loggedIn && globalNotifCount ? `(${globalNotifCount})` : ''}
  </PrependPageHeadTitle>

  {!!isAppointmentPublicPage && !!isPublicAppointment && (
    <header style={{ zIndex: 999  ,width: isMobile ? "100%" : "100%"}} className={styles.header}>
      <Stack
        pos="relative"
        w="100%"
        bg="white"
        boxShadow="0px 2px 10px 0px #00000033"
        borderBottom={'1px solid #ddd'}
        // zIndex={9999999}
      >
        <HStack py={[1, 4]} px={[null, 36]}>
          {!!getAccountInfo?.first_name && (
            <HStack
              cursor="pointer"
              onClick={() => {
                push(`/p/${getAccountInfo.slug}`);
              }}
            >
              {/* <Avatar color="white" name={getAccountInfo?.first_name+" "+getAccountInfo?.last_name ?? " "} size="sm" src={''} />
               <Text>{getAccountInfo?.first_name+" "+getAccountInfo?.last_name ?? " "}</Text> */}
              <HStack p={3} _hover={{ bg: '#F2F2F2' }} cursor="pointer">
                <Avatar
                  src={getAccountInfo?.profile_pic}
                  name={`${getAccountInfo?.first_name} ${getAccountInfo?.last_name}`}
                  size="md"
                />
                <Text
                  fontSize={["18px","20px"]}
                  fontWeight="600"
                  color="brandPrimary.500"
                >
                  {getUserFullName(getAccountInfo)}{' '}
                  {getAccountInfo?.pronouns
                    ? `(${getAccountInfo?.pronouns})`
                    : `(${t('myCalendar.sheHer') || 'She/Her'})`}
                </Text>
              </HStack>
            </HStack>
          )}

          <Spacer />
          {!!getAccountInfo?.appointment_profile && (
            <Button
              mr={[3, null]}
              py={[1, null]}
              onClick={() => {
                setOpenShareModal(true);
              }}
              fontSize="15px"
              borderRadius="full"
              bg="#3D5A80"
              color="#FFFFFF"
              variant="solid"
            >
              {t('post.share') || "Share"}
            </Button>
          )}
        </HStack>
      </Stack>
    </header>
  )}
  {!isAppointmentPublicPage && (
    <header className={styles.header} style={{ zIndex: 999  ,width: isMobileOrTablet&&isProfile?'100%':isMobileOrTablet&&!isProfile ? "-webkit-fill-available" : "100%"}}>
      <Stack
        pos="relative"
        w="100%"
        bg="white"
        // shadow={[0, 'md']}
        borderBottom={['1px solid #ddd', 0]}
      >
      <Stack  onClick={handleStopPropogation}>
        <HStack
          className={isPublicPage? className:''}
          // maxW="1366px"
          p={!isMobileOrTablet ? ['5px 10px 0', 2] : ''}
          pl={"0px !important"}
          justifyContent={["space-between", "space-between", "space-around"]}
          margin={!isMobileOrTablet ? "auto" : ''}
          // marginLeft={!isMobile ? '20px' : ''}
        >
          <HStack
            {...(side === 'rtl' 
              ? { pr: [0, 0, '0px'] } 
              : { pl: [1, 0, '0px'] }
            )}
            className={loggedIn 
              ? (side !== 'rtl' 
                  ? styles.paddingResponsive 
                  : styles.paddingResponsiveRTL) 
              : (side !== 'rtl' 
                  ? styles.paddingResponsivelogoutRTL 
                  : styles.paddingResponsivelogout)
            }
            display={
              // (isMobile || isTablet)
              (isMobileOrTablet)
                // ? (searchBoxDisc?.isOpen ? 'none' : 'flex')
                ? (loggedIn ? (searchBoxDisc?.isOpen ? 'none' : 'flex') : 'flex')
                : 'flex'
            }
          >
            <Box>
              {/* {isMobile || isTablet ? ( */}
              {isMobileOrTablet ? (
                <MyBridgeCircleIcon
                  width="44px"
                  onClick={() => sideDrawerDisc.onOpen()}
                />
              ) : (
                // <Link href="/">
                //   {/* <MyBridgeLogoMain width={isMobile ? '30px' : '44px'} /> */}

                //   <MyBridgeCircleIcon
                //     width={isMobile ? '30px' : '49px'}
                //     // onClick={() => sideDrawerDisc.onOpen()}
                //   />
                // </Link>

                <Link
                  href="/"
                  data-meeting-windowed-toggle
                  onClick={(e) => {
                    if (router.pathname === '/' && !isMeetingStarted) {
                      e.preventDefault();        // stop Next.js navigation
                      window.location.reload();
                    }
                  }}
                >
                  <MyBridgeCircleIcon
                    width={isMobile ? '30px' : '49px'}
                  />
                </Link>
              )}
            </Box>
          </HStack>
          <HStack
            {...(side === 'rtl' ? { pr: [0, 0, '0px'] } : { pl: [0, 0, '0px'] })}
            className={isMobileOrTablet&&!loggedIn ? styles?.rightResponsiveMoblie :isMobileOrTablet&&loggedIn?styles?.rightResponsiveMoblieLogedIn:loggedIn ? (side === 'rtl' ? styles.rightResponsiveRTL :  styles.rightResponsive): styles.rightResponsiveLogout}
            flex={'none'}
            display={
              // (isMobile || isTablet)
              (isMobileOrTablet)
                // ? (searchBoxDisc?.isOpen ? 'flex' : 'none')
                ? (loggedIn ? (searchBoxDisc?.isOpen ? 'flex' : 'none') : 'flex')
                : 'flex'
            }
          >
            <Box
              // w={!isMobile&&!loggedIn ? '580px':isMobile&&!setChatLoggedIn ? "280px": !isMobile && isJobsPage ?'580px':isMobile?'80vw':'360px'}
              w={!isMobileOrTablet&&!loggedIn ? '580px':isMobileOrTablet&&!loggedIn ? "calc(100vw - 80px)": !isMobileOrTablet && isJobsPage ?'580px':isMobileOrTablet?'80vw':'360px'}
            >
              {!isMobile && isJobsPage ? (
                <JobsListingSearchBar />
              ) : loggedIn ? (
                <>
                  {(!isMobile && !isTablet) || searchBoxDisc?.isOpen ? (
                    <Popover isOpen={searchBoxDisc.isOpen} onClose={searchBoxDisc.onClose}>
                      <PopoverTrigger>
                        <InputGroup>
                          <InputLeftElement
                            sx={{
                              _hover: {
                                cursor: 'pointer',
                              },
                            }}
                            width={['30px', '48px']}
                            height={['40px', '48px']}
                          >
                            <SearchIcon
                              onClick={(e) => {
                                handleSearchKeyDown(e, true);
                              }}
                              cursor="pointer"
                              width={isMobile ? '14px' : '18px'}
                            />
                          </InputLeftElement>
                          <Input
                            pl={10}
                            bg="brandGray.500"
                            border="none"
                            borderRadius="full"
                            value={tempSearch} // Controlled by tempSearch
                            onChange={handleInputChange} // Updates tempSearch
                            onClick={() => {
                              searchBoxDisc.onOpen();
                              setTimeout(() => {
                                inputRef.current?.focus();
                              }, 0);
                            }}
                            placeholder={
                              loggedIn
                                ? t('common.search') || 'Search...'
                                : t('common.searchFor') || 'Search for People, Jobs, Companies, Posts, Events, Teams, Articles...'
                            }
                            onKeyDown={handleSearchKeyDown} // API call on Enter
                            height={['40px', '48px']}
                            className={styles.srarchResponsive}
                          />
                        </InputGroup>
                      </PopoverTrigger>
                      <Portal>
                        <PopoverContent top={["4px","-1px"]} w={!isMobile&&!loggedIn ? '580px':isMobile&&!loggedIn ? "280px": ['100vw', '100vw', '358px']} className={styles.searchPopUp}>
                          <PopoverBody
                            style={{
                              outline: 'none',
                              borderRadius: (isMobile || isTablet) ? '0px' : '80px',
                              padding: '0',
                            }}
                          >
                            <InputGroup>
                              <InputLeftElement
                                sx={{
                                  _hover: {
                                    cursor: 'pointer',
                                  },
                                }}
                                width={['30px', '48px']}
                                height={['40px', '48px']}
                              >
                                <SearchIcon
                                  onClick={(e) => {
                                    handleSearchKeyDown(e, true);
                                  }}
                                  cursor="pointer"
                                  width={isMobile ? '14px' : '18px'}
                                />
                              </InputLeftElement>
                              <Input
                                pl={10}
                                bg="#FFFFFF"
                                border="none"
                                borderRadius={['0px', '0px', 'full']}
                                ref={inputRef}
                                value={tempSearch} // Controlled by tempSearch
                                onChange={handleInputChange} // Updates tempSearch
                                placeholder={
                                  loggedIn
                                    ? t('common.search') || 'Search...'
                                    : t('common.searchFor') || 'Search for People, Jobs, Companies, Posts, Events, Teams, Articles...'
                                }
                                onKeyDown={handleSearchKeyDown} // API call on Enter
                                height={['40px', '48px']}
                              />

                            </InputGroup>
                            <Box className={styles.searchPopUpBottomLine} />
                            <VStack
                              align="stretch"
                              className={styles.searchGroup}
                            >
                              <HStack justifyContent="space-between">
                                <Text
                                  fontSize="14px"
                                  color="black"
                                  fontWeight="600"
                                >
                                  {t('publicProfile.recent') || "Recent"}
                                </Text>
                                {newSearch?.length > 0 && (
                                  <Button
                                    variant="transparent"
                                    size="md"
                                    p={0}
                                    style={{
                                      fontWeight: '500',
                                      color: '#3D5A80',
                                    }}
                                    onClick={() => handleRecentDelete()}
                                  >
                                    {t('publicProfile.clearSearches') || "Clear Searches"}
                                  </Button>
                                )}
                              </HStack>
                              {!searchLoading ? (
                                newSearch?.length > 0 ? (
                                  newSearch.map((recent, i) => (
                                    <RecentSearchListBox
                                      key={i}
                                      recent={recent}
                                      onClick={() => {
                                        handleRecentSearch(recent?.query)
                                        setTempSearch(recent?.query)
                                        searchBoxDisc.onClose()
                                      }}
                                      cursor="pointer"
                                    />
                                  ))
                                ) : (
                                  <Text fontSize="12px" color="gray.500" py={2}>
                                    {"No recent searches"}
                                  </Text>
                                )
                              ) : (
                                <HStack justifyContent="center">
                                  <Spinner />
                                </HStack>
                              )}
                            </VStack>
                          </PopoverBody>
                        </PopoverContent>
                      </Portal>
                    </Popover>
                  ) : (
                    <></>
                  )}
                </>
              ) : (
                <>
                  {!isJobsPage && (
                    <InputGroup>
                      <InputLeftElement
                        sx={{
                          _hover: {
                            cursor: 'pointer',
                          },
                        }}
                        width={['30px', '48px']}
                        height={['40px', '48px']}
                      >
                        <SearchIcon
                          onClick={(e) => {
                            handleSearchKeyDown(e, true);
                          }}
                          cursor="pointer"
                          width={isMobileOrTablet ? '14px' : '18px'}
                        />
                      </InputLeftElement>
                      <Input
                        pl={10}
                        bg="brandGray.50"
                        border="none"
                        borderRadius="full"
                        value={tempSearch}
                        onChange={handleInputChange}
                        placeholder={
                          loggedIn
                            ? t('common.search') || 'Search...'
                            : t('common.searchFor') || 'Search for People, Jobs, Companies, Posts, Events, Teams, Articles...'
                        }
                        onKeyDown={handleSearchKeyDown}
                        height={['40px', '48px']}
                      />
                    </InputGroup>
                  )}
                  {isMobileOrTablet && isJobsPage && (
                    <JobsListingSearchBar />
                  )}
                </>
              )}
            </Box>
          </HStack>

          <HStack
            className={loggedIn ?  styles.notJobPage : styles.logoutRightStack }
            pl={loggedIn ? ['0px', '0px'] : '0px'}
            {...(direction === 'rtl' && loggedIn) ? { pl: [0, 0, '20px'] } : { pl: [0, 0, '0px'] }}
            justifyContent="end"
            display={
              // (isMobile || isTablet)
              (isMobileOrTablet)
                ? (searchBoxDisc?.isOpen ? 'none' : 'flex')
                : 'flex'
            }
          >
            <AuthHeader
              onSearchClose={() => searchBoxDisc?.onClose()}
              onSearchOpen={() => searchBoxDisc?.onToggle()}
            />
          </HStack>
        </HStack>
      </Stack>

        {/* {loading || !pageLoaded ? ( */}
        {(loggedIn && loading) || !pageLoaded ? (
          <Progress
            top={0}
            left={0}
            right={0}
            position="absolute"
            isIndeterminate
            h={1}
          />
        ) : (
          ''
        )}
      </Stack>
      {/* {(isMobile || isTablet) && loggedIn ? ( */}
      {(isMobileOrTablet) && loggedIn ? (
            <HStack
              onClick={() => {
                dispatch(setDashboardClicked(false));
                dispatch(setNotificationClicked(false));
              }}
              bg={"white"}
              borderBottom="1px solid #ddd"
              justifyContent="space-between"
              p="2% 0%"
            >
              <IconButton
                icon={<HomeIcon width="26" height="26" color={pathname === "/" ? "#4170A4" : "#5B5B5B"} />}
                variant="transparent"
                onClick={() => {
                  push('/')
                  dispatch(setDashboardClicked(false));
                  dispatch(setNotificationClicked(false));
                }}
              />
              <IconButton
                icon={<GroupIcon width="26" height="26" color={pathname === "/profile/network" ? "#4170A4" : "#5B5B5B"} />}
                variant="transparent"
                onClick={() => {
                  push('/profile/network')
                  dispatch(setDashboardClicked(false));
                  dispatch(setNotificationClicked(false));
                }}
              />
              <IconButton
                icon={<CalendarIcon width="24" height="24" color={pathname === "/profile/calendar" ? "#4170A4" : "#5B5B5B"} />}
                variant="transparent"
                // onClick={() => calendarDisc.onOpen()}
                onClick={() => {
                  push('/profile/calendar')
                  dispatch(setDashboardClicked(false));
                  dispatch(setNotificationClicked(false));
                }}
              />
              <IconButton
                icon={<FolderIcon width="26" height="26" color={pathname === "/profile/disk" ? "#4170A4" : "#5B5B5B"} />}
                variant="transparent"
                onClick={() => {
                  push('/profile/disk')
                  dispatch(setDashboardClicked(false));
                  dispatch(setNotificationClicked(false));
                }}
              />
              {/* {isMobile || isTablet ? <NotificationDropdown notifDisc={notifDisc}/> : <></>} */}
              {isMobileOrTablet ? <NotificationDropdown notifDisc={notifDisc}/> : <></>}

              <ProfileMenu>
                <IconButton
                  onClick={(e) => {
                    e.stopPropagation();
                    // dispatch(toggleDashboardClicked());
                    dispatch(setNotificationClicked(false));
                  }}
                  icon={<DashboardLayoutIcon width="26" height="26"  strokeColors={isDashboardClicked ? ['#4170A4', '#4170A4', '#4170A4', '#4170A4'] : ['#5B5B5B', '#5B5B5B', '#5B5B5B', '#5B5B5B']}/>}
                  variant="transparent"
                />
              </ProfileMenu>
            </HStack>
      ) : (
        <></>
      )}

      <MobileDrawerMenu
        onOpen={sideDrawerDisc?.isOpen}
        onClose={() => sideDrawerDisc?.onClose()}
      />
    </header>
  )}
  <ShareLinkModalPublic
    isOpen={openShareModal}
    onClose={handleCloseShareLinkModal}
  />
</>
  )}
    </>
  );
};

Header.propTypes = {};

export default Header;
